import React, { Component } from 'react';

import Title from './Title';

class Panel extends Component {
  render() {
    const { className, children } = this.props;

    return <div className={`card-box ${className}`}>{children}</div>;
  }
}

Panel.Title = Title;

export default Panel;
